
<template>
  <div class="hover-outer" v-if="onlyExceptions()">
    <mini-component v-if="options.type == 'mini'" :temp="temp"></mini-component>
    <full-component v-if="options.type == 'full'" :temp="temp"></full-component>
    <media-component v-if="options.type == 'media'" :temp="temp"></media-component>
    <vid-component v-if="options.type == 'vid'" :temp="temp"></vid-component>
  </div>
</template>

<script>

  import Full from './Full';
  import Media from './Media';
  import Vid from './Vid';
  import Mini from './Mini';

  export default {

    data(){
      return {
        temp: {}
      }
    },

    props: ['options'],

    components: {
      'mini-component': Mini,
      'full-component': Full,
      'media-component': Media,
      'vid-component': Vid
    },

    computed: {
      tutorial(){
        return this.$store.state.user.tutorial;
      }
    },

    methods: {

      compileHoverTemp(){
        if (this.options.temp){
          const template = require(`@/lib/hoverTemplates/${this.options.temp}.json`);
          const instance = template[this.options.instance];
          this.temp = {
            title: setReplacers(instance.title, this.options.replacers ? this.options.replacers : []),
            src: instance.src ? instance.src : '',
            content: instance.content.map(i => {
              return {
                sub: setReplacers(i.sub, this.options.replacers ? this.options.replacers : []),
                body: setReplacers(i.body, this.options.replacers ? this.options.replacers : [], true)
              }
            })
          }
          if (this.options.src) this.temp.src = this.options.src;
        } else {
          if (this.options.src) {
            this.temp = {
              src: this.options.src
            };
          } else {
            this.temp = this.options;
          }
        }
      },

      onlyExceptions(){
        if (this.$screen.breakpoint == 'sm') {
          return false;
        }
        if (this.options.exception) {
          return true;
        } else {
          return (this.$screen.breakpoint != 'sm' && this.tutorial);
        }
      }

    },

    mounted(){
      this.compileHoverTemp();
    }

  }

  function setReplacers(str, rep, lower){
    if (!rep.length) {
      return str;
    } else {
      let replaced = str.split(' ').map(i => {
        rep.forEach(r => {
          if (r.from == i) {
            i = r.to;
          }
        });
        return i;
      }).join(' ');
      return !lower ? upperCased(replaced) : replaced;
    }
  }

  function upperCased(str){
    return str.split(' ').map(i => `${i[0].toUpperCase()}${i.substring(1, i.length)}`).join(' ');
  }

</script>

<style>

.hover-outer {
  background: #404342;
  /* padding-left: 4%; */
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/components/hover/Hover.vue